import Vue from "vue";
import Vant from "vant";
import App from "./App.vue";
import router from "./router";
import store from "./store";


import "./utils/rem.js";
import "vant/lib/index.css";
import "./permission.js";

Vue.use(Vant);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
